import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withLocalize, Translate } from 'react-localize-redux';
import { Collapse } from 'reactstrap';
import { domainActions } from '../../../store/domainStore';
import { alertsActions, monthsAgo, daysAgo } from '../../../store/alertsStore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IdentitySection from './identitySection';
import CadastreSection from './cadastreSection';
import SelectTree from './selectTree';
import DateRange from './dateRange';
import Message from '../../common/message';
import { Formik, Form } from "formik";
import * as Yup from '../../common/Yup';
import { popupActions } from '../../../store/popupStore';
import { hasPermission } from '../../../store/apiWrapper';

import './alertsFilter.scss'

const M_ACTIVITY = {
    active: "active",
    inactive: "inactive"
};

class AlertsFilter extends React.Component {
    knownTypes = {
        'unknonw': () => (""),
        'select-tree': SelectTree,
        'select': IdentitySection,
        'cadastre': CadastreSection,
        'date-range': DateRange
    };

    popupSizes = {
        'events': 'small',
    };
    filters = () => [
        { TypeKey: 'select', Name: <Translate id="Alerts.Identification" />, Key: "identity", Permission: null },
        { TypeKey: 'cadastre', Name: <Translate id="Alerts.Cadastre.Identity" />, Key: "cadastre", Permission: "MonitoringCadastre" },
        { TypeKey: 'date-range', Name: <Translate id="Alerts.Notified.Date" />, Key: "notified", Permission: null },
        { TypeKey: 'date-range', Name: <Translate id="Alerts.Creation.Date" />, Key: "created", Permission: null },
        { TypeKey: 'select-tree', Name: <Translate id="Alerts.Event.Filter" />, Key: "events", Permission: null }
    ]

    state = {
        collapse: [],
        collapseAll: false,
        showAll: false
    };

    initialValues = {
        ico: "",
        dob: "",
        rc: "",
        fullName: "",
        regionId: "",
        districtId: "",
        municipalityId: "",
        cadastreUnitId: "",
        docNo: "",
        createdFrom: [daysAgo(90)],
        createdTo: "",
        notifiedFrom: [monthsAgo(1)],
        notifiedTo: "",
        events: [],
        filterUnreaded: true
    }

    render() {
        return (
            <>
                <Formik
                    ref={(el) => this.formRef = el}
                    enableReinitialize={true}
                    validationSchema={this.createValidationSchema()}
                    validateOnChange={false}
                    validateOnBlur={false}
                    initialValues={this.initialValues}
                    onReset={() => {
                        this.resetSearch();
                    }}
                    onSubmit={(values, { setSubmitting }) => {
                        setSubmitting(false);
                        this.submitSearch(values)
                    }}
                >
                    {({ values, setFieldValue, errors }) => (
                        <Form style={{ width: "100%", fontSize: "0.9em" }}>
                            {this.renderCollapseAll()}
                            {Object.keys(errors).length > 0 && <div className="column">
                                <Message type="error" message={this.props.translate("Error.InvalidParams")}>
                                </Message>
                            </div>}
                            {this.filters().map((f) => this.renderFilter(f, setFieldValue))}
                            {this.renderButtons()}
                        </Form>)}
                </Formik>
            </>
        );
    }

    renderCollapseAll = () => {
        return (
            <div className='search-filter-box-all'>
                <div className='search-filter-title' onClick={() => this.collapseAll()}>
                    <span>
                        <Translate id='Common.ShowHideAll' />
                    </span>
                    <FontAwesomeIcon className='svg-standard-color' icon={!this.state.collapseAll ? "angle-up" : "angle-down"} />
                </div>
            </div>
        );
    }

    renderFilter = (filter, setFieldValue) => {
        const input = {
            value: {
                [M_ACTIVITY.active]: 1,
                [M_ACTIVITY.inactive]: 2
            },
            checked: {
                [M_ACTIVITY.active]: !this.state.showAll,
                [M_ACTIVITY.inactive]: this.state.showAll
            },
            label: {
                [M_ACTIVITY.active]: 'Alerts.ShowUnread',
                [M_ACTIVITY.inactive]: 'Alerts.ShowAll'
            },
        };

        if (filter.Permission === null || hasPermission(null, filter.Permission)) {
            const TagName = this.knownTypes[filter.TypeKey] || this.knownTypes["unknonw"];
            return (
                <div>
                    {filter.TypeKey === 'cadastre' &&
                        <div className={classnames("settings-row")}>
                            <div className={classnames("settings-selector")} style={{ margin: '0px auto' }}>
                                {Object.keys(input.value).map(j => (
                                    <React.Fragment key={j}>
                                        <span data-active={input.checked[j]}
                                            onClick={() => {
                                                this.setState({ showAll: j === M_ACTIVITY.inactive });
                                                setFieldValue('showAll', !this.state.showAll);
                                            }}
                                        >
                                            {input.label ? this.props.translate(input.label[j]) : ""}
                                        </span>
                                    </React.Fragment>
                                ))}

                            </div>
                        </div>
                    }

                    <div className='search-filter-box' key={filter.Key}>
                        <div className='search-filter-title' onClick={() => this.toggle(filter.Key)}>
                            <span>
                                {filter.Name}
                            </span>
                            <FontAwesomeIcon className='svg-standard-color' icon={!this.state.collapse[filter.Key] ? "angle-up" : "angle-down"} />
                        </div>
                        <Collapse isOpen={!this.state.collapse[filter.Key]}>
                            <TagName filter={filter} popupSize={this.popupSizes[filter.Key]} />
                        </Collapse>
                    </div>
                </div>
            );
        }
    }

    renderButtons = () => {
        return (
            <div className='search-filter-box-apply'>
                <button className={classnames('bb-button small gradient-1-gray', { 'is-square': localStorage.locales_button_style === 'square' })} type="reset">
                    <Translate id="Search.Common.Reset" />
                </button>
                <button className={classnames('bb-button small gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })} type="submit">
                    <Translate id="Search.FilterApply" />
                </button>
            </div>
        );
    }

    validateRange(field, values) {
        if (values[field + 'From'] !== '') {
            if (values[field + 'From'][0] < monthsAgo(6)) {
                this.showPopup("Monitoring.PortfolioSearch.StartDateFormat");
                return false;
            }
            if (values[field + 'To'] !== '') {
                if (values[field + 'From'][0] > values[field + 'To'][0]) {
                    this.showPopup("Monitoring.PortfolioSearch.InvalidRange");
                    return false;
                }
            }
        }
        if (values[field + 'To'] !== '') {
            if (values[field + 'To'][0] > monthsAgo(0)) {
                this.showPopup("Monitoring.PortfolioSearch.EndDateFormat");
                return false;
            }
        }
        return true
    }

    submitSearch(values) {
        if (!this.validateRange("notified", values) || !this.validateRange("created", values))
            return false;

        this.props.setFilter(values);
    }

    resetSearch() {
        this.props.resetSearchFilters();
    }

    toggle = (item) => {
        const newState = { ...this.state };
        newState.collapse[item] = !this.state.collapse[item];
        this.setState(newState);
    }

    collapseAll = () => {
        const newState = { ...this.state };
        newState.collapseAll = !newState.collapseAll;
        this.filters().map(item =>
            newState.collapse[item.Key] = newState.collapseAll);
        this.setState(newState);
    }

    componentDidMount() {
    }

    createValidationSchema = () => {
        const wrongInputMsg = this.props.translate("Search.Common.Validation.WrongInput");
        return Yup.object().shape({
            /*"regionId": Yup.number().integer(),
            "districtId": Yup.number().integer(),
            "municipalityId": Yup.number().integer(),
            "ico": Yup.number().integer().when()
            "createdFrom": Yup.date().test('test-name', 'Failled msg', function (value) { return (value < new Date()) })*/
        });
    }

    showPopup(msg) {
        this.props.showPopup('informationMessagePopup', {
            open: true,
            close: () => this.props.hidePopup(),
            message: this.props.translate(msg)
        });
    }
}

export default withLocalize(connect(
    state => ({ domain: state.domain, alerts: state.alerts }),
    dispatch => bindActionCreators(({ ...domainActions, ...alertsActions, ...popupActions }), dispatch),
)(AlertsFilter));
